<template>
  <center>
    <div>
      <div class="card card-body agatrs-card-style">
        <Header pageTitle="Edit ACSA" class="card-container"></Header>
        <div class="row">
          <div class="col-md-6">
            <label>ACSA Name</label>
            <base-input
              v-model="selectedName"
              name="Name"
              placeholder="Please type name."
            ></base-input>
            <label>ACSA Remark</label>
            <base-input
              v-model="selectedRemark"
              name="Remark"
              placeholder="Please type a remark."
            ></base-input>
          </div>

          <div class="col-md-6">
            <el-table :data="acsaAgreements.files" role="table"
        aria-label="ACSA Files Table">
              <el-table-column :min-width="50" align="left" label="Actions">
                <div slot-scope="props">
                  <el-tooltip
                    content="Download Document"
                    :open-delay="300"
                    effect="light"
                    placement="top"
                  >
                    <router-link
                      :to="`/api/acsaagreementfiles/${props.row.id}`"
                      class="btn-link btn-primary"
                      target="_blank"
                    >
                      <i class="tim-icons icon-cloud-download-93"></i>
                      <span class="hide-if-large-screensize">Download</span>
                    </router-link>
                  </el-tooltip>
                  <el-tooltip
                    content="Delete File."
                    :open-delay="300"
                    effect="light"
                    placement="top"
                  >
                    <a
                      href="#"
                      @click="deleteFile(props.row.id, props.row.file.name)"
                      class="btn-link btn-danger"
                    >
                      <i class="tim-icons icon-trash-simple"></i>
                      <span class="hide-if-small-screensize">Delete</span>
                    </a>
                  </el-tooltip>
                </div>
              </el-table-column>
              <el-table-column
                v-for="fileColumn in filesColumns"
                :key="fileColumn.label"
                :min-width="fileColumn.minWidth"
                sortable
                :formatter="fileColumn.formatter"
                :prop="fileColumn.prop"
                :label="fileColumn.label"
              >
              </el-table-column>
            </el-table>
            <div class="col-md-4 offset-md-2">
              <base-button
                @click="openModal()"
                class="btn-dark float-sm-none float-md-left"
                ><i class="tim-icons icon-simple-add"></i> New ACSA File
              </base-button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 align-left">
            <div class="col-md-4">
              <base-button
                type="primary"
                @click="returnToEditAcsas()"
                class="btn-primary"
              >
                <i class="tim-icons icon-double-left"></i> Return (Edit ACSAs)
              </base-button>
            </div>
            <div class="col-md-2 offset-md-7">
              <base-button
                @click="saveAcsaAgreement()"
                class="btn"
                type="primary"
              >
                <i class="tim-icons icon-send"></i> Save ACSA
              </base-button>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        ref="showAcsaModal"
        scrollable
        hide-footer
        hide-header
        no-close-on-backdrop
        size="lg"
        body-class="custom_alert_body"
      >
        <div class="alert_header align-center">Add ACSA Document</div>

        <div class="container">
          <label>ACSA File Upload:</label>
          <base-input class="pt-20" :error="getError('file')">
            <input
              v-validate="'required'"
              name="file"
              accept=".xls,.xslx,.png,.jpg,.jpeg,.pdf"
              type="file"
              ref="file"
              @change="handleFileUpload"
              placeholder="ACSA Document"
            />
            <b
              ><small
                >*PDF/XLS/PNG/JPG Document files with a size less than
                10MB</small
              ></b
            >
          </base-input>
        </div>

        <div class="alert_footer align-center">
          <base-button
            type="primary"
            @click="clickCloseModal()"
            class="btn-primary"
            ><i class="tim-icons icon-double-left"></i> Back</base-button
          >
          <base-button
            @click="saveAcsaFile()"
            class="btn float-right"
            type="primary"
            ><i class="tim-icons icon-cloud-upload-94"></i> Upload
          </base-button>
        </div>
      </b-modal>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn } from "element-ui";
import axios from "@/axios";
import swal from "sweetalert2";
import Header from "@/components/App/Header.vue";
import Utility from "@/mixins/utility/utility";
import Util from "@/util/util";
export default {
  name: "EditAcsaFiles",
  mixins: [Utility],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Header,
  },
  data() {
    return {
      acsaAgreements: [],
      file: "",
      selectedName: "",
      selectedRemark: "",
      filesColumns: [
        {
          prop: "id",
          label: "File ID",
          minWidth: 50,
          scope: "col"
        },
        {
          prop: "file.name",
          label: "Name",
          minWidth: 50,
          scope: "col"
        },
      ],
    };
  },
  mounted() {
    this.getAcsasByAcsaId();
  },
  methods: {
    ...mapActions({
      saveAcsaFile: "acsaAgreement/saveAcsaFile",
      getAcsaAgreement: "acsaAgreement/getAcsaAgreement",
    }),
    getAcsasByAcsaId() {
      this.axios
        .get(`api/acsaagreements/${this.$route.params.id}`)
        .then((response) => {
          this.acsaAgreements = response.data;
          this.selectedName = response.data.name;
          this.selectedRemark = response.data.remark;
        });
    },
    openModal() {
      this.$refs.showAcsaModal.show();
    },
    clickCloseModal() {
      this.$refs.showAcsaModal.hide();
    },
    deleteFile(fileId, fileName) {
      new swal({
        title: "Delete Confirmation",
        text: `Do you want to delete: "${fileName}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: `Delete File #${fileId}!`,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          axios
            .delete(`api/acsaagreementfiles/delete/${fileId}`)
            .then((response) => {
              new swal({
                title: "Confirmation of Delete",
                text: `"${fileName}" has been deleted successfully.`,
                icon: "success",
                confirmButtonColor: "#10b45a",
              });
              this.getAcsasByAcsaId();
            });
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    returnToEditAcsas() {
      this.$router.push(`/admin/acsas/${this.acsaAgreements.countryId}`);
    },
    saveAcsaAgreement() {
      let newAcsaAgreement = {
        countryId: this.acsaAgreements.countryId,
        acsaAgreementId: this.$route.params.id,
        name: this.selectedName,
        remark: this.selectedRemark,
      };
      axios.post("api/acsaagreements", newAcsaAgreement).then((response) => {
        this.getAcsasByAcsaId();
      });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    saveAcsaFile() {
      let ctx = this;
      ctx.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!Util.isSupportedFile(ctx.file.name)) {
            ctx.showAlertDialog("Alert", "Invalid File Type!");
            return false;
          }
          let formData = new FormData();

          formData.append("agreementId", ctx.acsaAgreements.acsaAgreementId);
          formData.append("IFile", ctx.file);

          axios
            .post("/api/acsaagreementfiles/", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(() => {
              this.clickCloseModal();
              this.getAcsasByAcsaId();
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.form-group input[type="file"] {
  opacity: inherit;
  position: inherit;
  top: inherit;
  right: inherit;
  bottom: inherit;
  left: inherit;
  width: inherit;
  height: inherit;
  z-index: inherit;
}
</style>
